import { ValuesType } from 'utility-types';
import { GAME_MODE } from '~/interfaces';

const singleTrackGameModes = [GAME_MODE.DUEL] as const;
const multiTrackGameModes = [GAME_MODE.DUEL, GAME_MODE.PASS_THE_MIC, GAME_MODE.CO_OP] as const;

export const getAvailableGameModes = (tracksCount: number): readonly ValuesType<typeof GAME_MODE>[] =>
  tracksCount > 1 ? multiTrackGameModes : singleTrackGameModes;

export const resolveGameMode = (
  tracksCount: number,
  rememberedMode: ValuesType<typeof GAME_MODE> | null,
): ValuesType<typeof GAME_MODE> => {
  const availableModes = getAvailableGameModes(tracksCount);

  if (rememberedMode !== null && availableModes.includes(rememberedMode)) {
    return rememberedMode;
  }

  return tracksCount > 1 ? GAME_MODE.CO_OP : GAME_MODE.DUEL;
};